import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { Button, Popover, Space, Switch, Tooltip } from 'antd';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import fetchApi from '../../../utils/api/fetchApi';
import AntdNotification from '../../../utils/extend/AntdNotification';
import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification';

const WebComponent = (props: any) => {
    const title = '会员交易明细';
    let wmService: any = systemConfig.wmService;

    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [InitData, setInitData] = useState<any>();
    const [activePopoverId, setActivePopoverId] = useState<string | null>(null);

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            setDefaultService(ref.current.defaultService);
            setInitData(() => ref.current.initData);
        }
        //同步获取数据 async - await
        // const fetchData = async () => {
        // }
        // fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据
    const printMembership = (apiData: any) => {

        fetchApi.GET(wmService, {
            apiId: "membershipTransactionDetails",
            apiExtend: 'printMembership',
            apiData: {
                id: apiData.id,
                branchStoreId: apiData.shopId
            }
        }).then((res) => {

            if (res.success) {
                antMessage("success", "打印命令已发送")

            }
        }).catch((err) => {
            antMessage("error", "命令发送失败", JSON.stringify(err))

        })
    }
    //表头
    const columnsHead = [
        {
            title: '类型',
            dataIndex: 'membershipTransactionType',
            render: (val: any, record: any) =>
                < Tooltip placement="topLeft" title={`商户：${record?.merchantId}；
            商户单类型：${record?.merchantOrderTypeId}；
            商户单号：${record?.merchantOrderId}`} > {
                        val?.name
                    }</Tooltip>
        },
        {
            title: '方案',
            dataIndex: 'membershipRechargePlans',
            render: (text: any) => text?.planName
        },
        {
            title: '店铺',
            dataIndex: 'shop',
            render: (text: any) => text?.shopName
        },
        {
            title: '交易日期',
            dataIndex: 'sysDate',
            render: (text: any) => dayjs(text.createdAt).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '余额变动',
            dataIndex: 'balanceChange',
            render: (val: number) => <text style={{ color: 'yellow' }}>{val}</text>
        },
        {
            title: '现余额',
            dataIndex: 'currentBalance'

        },
        {
            title: '赠送变动',
            dataIndex: 'giftsChange',
            render: (val: number) => <text style={{ color: 'yellow' }}>{val}</text>
        },
        {
            title: '现赠送',
            dataIndex: 'currentGifts'

        },
        {
            title: '积分变动',
            dataIndex: 'membershipPointsDetailses',
            render: (val: any) => {
                let text = '';
                for (let i = 0; i < val.length; i++) {
                    text += `${val[i].pointsChange}；`
                }
                return (<text style={{ color: 'yellow' }}>{text}</text>)
            }
        },
        {
            title: '兑换金额',
            dataIndex: 'membershipPointsDetailses',
            render: (val: any) => {
                let text = '';
                for (let i = 0; i < val.length; i++) {
                    const pointsRedeemAmount = val[i].pointsRedeemAmount;
                    if (pointsRedeemAmount !== 0) {
                        text += `${pointsRedeemAmount}；`;
                    }
                }
                return (<text style={{ color: 'red' }}>{text}</text>)
            }
        },
        {
            title: '现积分',
            dataIndex: 'membershipPointsDetailses',
            render: (val: any) => {
                let text = `${val[val.length - 1]?.currentPoints}`;
                return (<>{text !== 'undefined' ? text : ''}</>)
            }
        },
        {
            title: '成功',
            dataIndex: 'isTransactionSuccessful',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '成功日期',
            dataIndex: 'successfulDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '撤销',
            dataIndex: 'isTransactionVoid',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '撤销日期',
            dataIndex: 'transactionVoidDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '',
            dataIndex: 'id',
            render: (id: string, record: any) => (
                (record.isTransactionSuccessful === true && (record.membershipTransactionTypeId === 1) && record.isTransactionVoid === false) ?
                    <Popover
                        title="是否撤销？"
                        trigger="click"
                        content={(<Space>
                            <Button onClick={() => setActivePopoverId(null)}>否</Button>
                            <Button  type='primary' onClick={() => {
                                fetchApi.PUT(defaultService,
                                    {
                                        apiId: 'membership',
                                        apiExtend: 'transactionVoid',
                                        apiData: {
                                            membershipTransactionDetailsId: id
                                        }
                                    }).then(res => {
                                        if (res?.success === true) {
                                            AntdNotification('success', '执行撤销成功');
                                            InitData();
                                        } else {
                                            AntdNotification('error', res?.message);
                                        }
                                    });
                                setActivePopoverId(null);
                            }}>是</Button>
                        </Space>)}
                        open={activePopoverId === id}
                        onOpenChange={(visible) => {
                            setActivePopoverId(visible ? id : null);
                        }}
                    >
                        <Button danger type="dashed" >撤销</Button>
                    </Popover> : null)
        },
        {
            title: '打印',
            dataIndex: 'successfulDate',
            render: (text: any, record: any) => {
                return <Button onClick={() => printMembership(record)}>打印</Button>
            }
        },

    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: title,
        apiId: 'membershipTransactionDetails',
        columns,
        pagination: true,
        showStates: false,
        // EditComponent,
        serviceId: 'business',
        showEdit: false,
        showAdd: false,
        showDelete: false,
        sendPageData: data
    };

    return (
        <>
            <AntDraggableModal
                title={title}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={1500} >
                <WebUniversalNewEx props={extendProps} ref={ref} />
            </AntDraggableModal>
        </>
    )
}

export default WebComponent;
